// Add your custom JS here.

  document.addEventListener("DOMContentLoaded", function () {
    const toggleBtn = document.querySelector(".navbar-toggler");
    const offcanvas = document.querySelector("#navbarNavOffcanvas");

    offcanvas.addEventListener("show.bs.offcanvas", () => {
      toggleBtn.classList.add("active");
    });

    offcanvas.addEventListener("hide.bs.offcanvas", () => {
      toggleBtn.classList.remove("active");
    });
  });

jQuery(document).ready(function() {
		jQuery(window).scroll(function() {
			if (jQuery(this).scrollTop() > 80) {
				jQuery('#main-nav').addClass('scroll-more');
			} else {
				jQuery('#main-nav').removeClass('scroll-more');
			}
		});
	});